/**
 * AlertsStack Component
 *
 * This component acts as a global alert container for the web application.
 * It listens to the alert state from the SessionContext and renders one or more
 * DstAlert modals accordingly. This ensures alerts can be triggered and displayed
 * from anywhere in the app in a centralized, consistent manner.
 */
import React from "react";

import { useSession } from "../../contexts/SessionContext";
import DstAlert from "../DstAlert/DstAlert";

const AlertsStack = () => {
  const { alerts, popAlert } = useSession();
  const current = alerts?.[0];

  return current ? <DstAlert show onHide={popAlert} {...current} /> : null;
};

export default AlertsStack;
